import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { FloatingTree, useFloatingParentNodeId } from '@floating-ui/react';
import { MenuLeaf } from './MenuLeaf';
export const Menu = forwardRef(function MenuParent(props, forwardedRef) {
    const parentId = useFloatingParentNodeId();
    if (parentId === null) {
        return (_jsx(FloatingTree, { children: _jsx(MenuLeaf, { ...props, ref: forwardedRef }) }));
    }
    return _jsx(MenuLeaf, { ...props, ref: forwardedRef });
});
